import { useCommonClient } from '@/app/common/commonClientProvider';
import getSearchParams from '@/app/components/search/common/getSearchParams';
import { useInitialParams } from '@/app/components/hotel-detail/InitialParamsProvider';
import { createFlightPageFilterPayload } from '@/app/common/starTrack/events/flightPageFilter';

export const useTransportPageFilterTracking = () => {
  const { starTrack } = useCommonClient();
  const searchParams = getSearchParams();
  const { productDetailKey } = useInitialParams();

  return ({ filterName, value, deselectFlag }: StartrackFilterPayload) => {
    starTrack.flightPageFilter(
      createFlightPageFilterPayload({ searchParams, productDetailKey, filterName, value, deselectFlag })
    );
  };
};
